import axios from 'axios'
import config from '../config'

export default async (type, url, data, header = {}) => {
  if (!config.api.token) {
    config.api.token = localStorage.getItem('JWT')
  }

  if (!config.api.token) {
    // Navigate to Logout here.
  }

  const defaultHeader = {
    headers: { Authorization: config.api.token }
  }

  try {
    if (type === 'get' || type === 'delete') {
      return axios[type](url, Object.assign(defaultHeader, header))
    } else {
      return axios[type](url, data, Object.assign(defaultHeader, header))
    }
  } catch (e) {
    if (e.toString().indexOf('status code 401') >= 0) {
      // Navigate to Logout here.
    }
    throw e
  }
}
